import React, { FC } from 'react';

import lang from '../../lib/language';

import IconError from '../../assets/img/error-x.png';
import Layout from '../Enrollment/component/Layout';

import styles from './ErrorLayout.module.scss';

type OwnProps = {
  handleClose: () => void;
  handleSubmit: () => void;
};

const ErrorLayout: FC<OwnProps> = (props: OwnProps): JSX.Element => {
  const { handleClose, handleSubmit } = props;

  return (
    <Layout
      formTitle={''}
      onSubmit={handleSubmit}
      onBackBtnPress={handleClose}
      nextButtonText={lang.commonButtonsTryAgain()}
      displayFooter
      displayLoginButton={false}
      displayNextButton
      displayBackButton={false}
      transparentContent
    >
      <div className={styles.wrapper}>
        <img alt="X" src={IconError} />
        <div className={styles.title}>{lang.mobileFundsScreenFailedCardDepositDialog()}</div>
        <div className={styles.description}>{lang.planPaymentErrorLostConnection()}</div>
      </div>
    </Layout>
  );
};
export default ErrorLayout;
